// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._16jlkb7n{flex-grow:1}\n._18u01ivi{margin-left:calc(var(--container-gap-left)*-1)}\n._1bsb129b{width:calc(100% + var(--container-gap-left) + var(--container-gap-right))}\n._1e0c1txw{display:flex}\n._2hwxc10g{margin-right:calc(var(--container-gap-right)*-1)}\n._2lx21bp4{flex-direction:column}\n._vchhusvi{box-sizing:border-box}", ""]);
// Exports
module.exports = exports;
